import simpleFormConverter from './FormUtils/simpleFormConverter';
import simpleFormExtractor from './FormUtils/simpleFormExtractor';


// slice is store.forms.forms.(label)
export const extractValuesFromStore = ( slice ) =>
  Object.fromEntries(Object.entries( slice.state )
  .filter( ([k,v]) => !k.startsWith('X'))
  .map( ([k,v]) => [k,v.value] )); 
// extractValuesFromStore


const FormUtils = {};

FormUtils.extractValuesFromStore = extractValuesFromStore;
FormUtils.simpleFormConverter = simpleFormConverter;
FormUtils.simpleFormExtractor = simpleFormExtractor;

export default FormUtils;